import axios from 'axios'

export default {
  // 返却メール記載のURLからアクセスした場合に日時を記録する
  async countMailAccess(examId: string, nendo: number) {
    try {
      await axios.post(`/api/v1/submit/mail_accesses`, { exam_id: examId, nendo: nendo })
    } catch(e) {
      return { status: 'error', message: e }
    }
  },
}
